import {
    COMPANY_ADMIN_ORGANIZATION_USERS_CREATE_ROUTE,
    TENANT_USERS_CREATE_USER_ROUTE,
} from "../../../../../../constants/routes"

export function userType(route: string) {
    switch (route) {
        case COMPANY_ADMIN_ORGANIZATION_USERS_CREATE_ROUTE:
            return "company"
        case TENANT_USERS_CREATE_USER_ROUTE:
            return "tenant"
        default:
            return "tenant"
    }
}
